import { render } from "./saleBalance.vue?vue&type=template&id=98597162&scoped=true"
import script from "./saleBalance.vue?vue&type=script&lang=js"
export * from "./saleBalance.vue?vue&type=script&lang=js"

import "./saleBalance.vue?vue&type=style&index=0&id=98597162&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98597162"]])

export default __exports__